var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhoneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#07086E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0317 21.9982C25.0208 26.2023 25.9258 21.3386 28.4656 24.0143C30.9143 26.5949 32.3216 27.112 29.2192 30.3816C28.8306 30.7108 26.3616 34.6717 17.6846 25.5269C9.00652 16.381 12.7616 13.7755 13.074 13.366C16.1839 10.0873 16.6659 11.5796 19.1145 14.1602C21.6544 16.837 17.0427 17.7941 21.0317 21.9982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneBlue);
export default __webpack_public_path__ + "static/media/ic_phone_blue.6d2a01f0b28ebbe6afc05f265bc3abb4.svg";
export { ForwardRef as ReactComponent };